<template>
  <v-container fluid class="py-2 px-0" style="min-height: calc(100vh - 64px);">
      
    <!-- SECTION STRUCTURE DETAILS LOADING-->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="structureLoading && translatedContentStructure.type !== 'STRUCTURE_MENU' ">
      <!-- DETAILS LOADING -->
      <div class="col-12 ma-0 my-2 pa-0">
        <v-container fluid class="pa-2">
            <div class="px-2" v-if="structureLoading">
                <div class="d-flex justify-space-between">
                    <div class="col-12 pa-2 ma-0">
                        <v-card
                                flat
                                color="transparent"
                        >
                            <v-skeleton-loader
                                    type="image"
                            ></v-skeleton-loader>
                        </v-card>
                    </div>
                </div>
            </div>

            <v-divider class="my-3"></v-divider>
        </v-container>
      </div>
    </div>
    
    <!-- SECTION STRUCTURE DETAILS / PLAYER -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="!structureLoading && translatedContentStructure.type !== 'STRUCTURE_MENU' ">
      <!-- STRUCTURE DETAILS / PLAYER -->
      <div class="col-12 ma-0 my-2 pa-0">
        <v-container fluid class="pa-2">
          <!-- DETAILS SECTION -->
          <div class="px-2" v-if="translatedContentStructure.translation && (translatedContentStructure.type !== 'VIMEO' || (translatedContentStructure.translation.vimeoType === 'INTRODUCTION' && $moment().isBefore($moment(translatedContentStructure.translation.properties.scheduledAt)))) && translatedContentStructure.type !== 'FUNXTION_VIRTUAL_CLASS'">
                <div class="d-flex justify-space-between flex-wrap flex-md-row-reverse">
                    
                  <div class="col-12 col-md-5 pa-2 ma-0">
                        <v-img
                                v-if="translatedContentStructure.asset.properties && translatedContentStructure.asset.properties.thumbnailUrl"
                                :src="translatedContentStructure.asset.properties.thumbnailUrl"
                                lazy-src="/assets/img/placeholder.png"
                                :aspect-ratio="16/9"
                                class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                                eager
                                cover
                        >
                          <span class="white--text text-h4 font-weight-bold" style="text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);">{{ translatedContentStructure.translation.title }}</span>
                        </v-img>
                        <v-img
                            v-else-if="translatedContentStructure.translation && translatedContentStructure.translation.thumbnailUrl"
                            :src="translatedContentStructure.translation.thumbnailUrl"
                            class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                            lazy-src="/assets/img/placeholder.png"
                            :aspect-ratio="16/9"
                            eager
                            cover
                        >
                          <span class="white--text text-h4 font-weight-bold" style="text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);">{{ translatedContentStructure.translation.title }}</span>
                        </v-img>
                      <v-img
                          v-else
                          src="/assets/img/placeholder.png"
                          class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                          lazy-src="/assets/img/placeholder.png"
                          :aspect-ratio="16/9"
                          eager
                          cover
                      >
                        <span class="white--text text-h4 font-weight-bold" style="text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);">{{ translatedContentStructure.translation.title }}</span>
                      </v-img>
                    </div>

                  <div class="col-12 col-md-5 pa-2 ma-0">
                        <v-card
                                flat
                                color="transparent"
                        >
                            <v-card-title class="text-break" v-if="translatedContentStructure.translation"><strong>{{ translatedContentStructure.translation.title || '' }}</strong></v-card-title>
                            <v-card-subtitle class="text-break" v-if="translatedContentStructureParent && translatedContentStructureParent.asset"><a @click.prevent="navigateStructure(structureParent)">{{ translatedContentStructureParent.translation.title }}</a></v-card-subtitle>
                            <v-card-subtitle class="pt-0 text-break" v-if="translatedContentStructure.translation.vimeoType === 'INTRODUCTION'"><v-chip color="primary" class="rounded-lg"><span class="text-capitalize">{{ $moment(translatedContentStructure.translation.properties.scheduledAt).fromNow() }}</span></v-chip> - {{ $moment(translatedContentStructure.translation.properties.scheduledAt).format('L LT') }}</v-card-subtitle>
                            <v-card-text v-html="translatedContentStructure.translation.description">
                            </v-card-text>
                        </v-card>
                    </div>
                </div>

                <v-divider class="my-3"></v-divider>
            </div>

          <!-- TYPEFORM SECTION -->
          <div class="px-2" v-if="translatedContentStructure.translation && translatedContentStructure.type === 'TYPEFORM' && surveyReady">
            <div
                class="pa-2"
                id="wrapper"
                :data-tf-widget="translatedContentStructure.translation.typeformCode"
                data-tf-inline-on-mobile
                data-tf-medium="snippet"
                :data-tf-hidden="'id=' + userId"
                style="height: calc(100vh - 88px - 36px);"
            ></div>

            <v-divider class="my-3"></v-divider>
          </div>
          
          <!-- PDF SECTION -->
          <div class="px-2" v-if="translatedContentStructure.translation && translatedContentStructure.type === 'PDF'">
            <iframe :src="'/pdf-embed?slug=' + translatedContentStructure.translation.pdfFileName + '.pdf&url=' + translatedContentStructure.translation.pdfUrl" style="height: calc(100vh - 88px - 44px); width: 100%; border: none;" class="pa-0 ma-0"></iframe>

            <v-divider class="my-3"></v-divider>
          </div>

          <!-- PLAYER SECTION -->
          <div class="px-2" v-if="translatedContentStructure.translation && translatedContentStructure.type === 'VIMEO' && (translatedContentStructure.translation.vimeoType !== 'INTRODUCTION' || (translatedContentStructure.translation.vimeoType === 'INTRODUCTION' && $moment().isAfter($moment(translatedContentStructure.translation.properties.scheduledAt))))">
              <!-- PLAYER -->
              <div class="d-flex justify-space-between" v-if="!isMovieLoading">
                  <div class="col-12 pa-2 ma-0">
                      <v-card
                          flat
                          color="transparent"
                          class="d-flex justify-center"
                          height="60vh"
                      >
                        <iframe @load="logPlayer()" id="video" :data-matomo-title="translatedContentStructure.translation.name || ''" :src="translatedContentStructure.translation.properties.playerEmbedUrl + '&sharing=0&api=1&chromeless=0&volume=100'" height="100%" width="100%" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen loading="eager"></iframe>
                      </v-card>
                  </div>
              </div>
              <!--<div class="d-flex justify-space-between" v-if="isMovieLoading">
                  <div class="col-12 pa-2 ma-0">
                      <v-card
                              flat
                              color="transparent"
                              class="d-flex justify-center"
                              height="60vh"
                      >
                          <template v-if="collection['live_video'] && collection['live_status'] === 'pending'">
                              <v-img
                                      v-if="collection.thumbnail"
                                      :src="collection.thumbnail"
                                      contain
                                      eager
                              ></v-img>
                          </template>
                          <template v-else>
                              <iframe @load="logPlayer()" id="video" v-if="collection.metadata['series_id']" :src="movie.direct + '&sharing=0&api=1&chromeless=0&volume=100&context=' + encodeURI(baseUrl + '/series/' + collection.metadata['series_id'])+ '&back=' + collection.metadata['series_name']" height="100%" width="100%" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen loading="eager"></iframe>
                              <iframe @load="logPlayer()" id="video" v-if="!collection.metadata['series_id']" :src="movie.direct + '&sharing=0&api=1&chromeless=0&volume=100'" height="100%" width="100%" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen loading="eager"></iframe>
                          </template>
                      </v-card>
                  </div>
              </div>-->

              <!-- PLAYER DETAILS -->
              <div class="d-flex justify-space-between flex-wrap" v-if="!isMovieLoading">
                  <div class="col-12 col-lg-6 pa-2 ma-0">
                      <v-card
                              flat
                              color="transparent"
                      >
                          <v-card-subtitle class="pb-0 text-break" v-if="structureParent"><a @click.prevent="navigateStructure(structureParent)">{{ translatedContentStructureParent.translation.title }}</a></v-card-subtitle>
                          <v-card-title class="pt-0 text-break"><strong>{{ translatedContentStructure.translation.title || '' }}</strong></v-card-title>
                          <v-card-subtitle class="text-break py-0" v-if="translatedContentStructure.translation.duration">{{ translatedContentStructure.translation.duration > 3600 ? $moment.utc(translatedContentStructure.translation.duration*1000).format("HH:mm:ss") : $moment.utc(translatedContentStructure.translation.duration*1000).format("mm:ss") }}</v-card-subtitle>
                          <v-card-subtitle class="pt-0 text-break" v-if="translatedContentStructure.translation.vimeoType === 'INTRODUCTION'">{{ $moment(translatedContentStructure.translation.properties.scheduledAt).format('L LT') }}</v-card-subtitle>
                          <v-card-text v-html="translatedContentStructure.translation.description">
                          </v-card-text>
                      </v-card>
                  </div>
              </div>

              <v-divider class="my-3"></v-divider>
          </div>

          <!-- VIDEOJS PLAYER SECTION -->
          <div class="px-2" v-if="translatedContentStructure.translation && translatedContentStructure.type === 'FUNXTION_VIRTUAL_CLASS'">
            <!-- PLAYER -->
            <div class="d-flex justify-space-between" v-if="!isMovieLoading">
              <div class="col-12 pa-2 ma-0">
                <v-card
                    flat
                    color="transparent"
                    class="d-flex justify-center"
                    height="60vh"
                >
                  <m2h-video-player v-if="translatedContentStructure.translation && translatedContentStructure.translation.funxtionVideoUrl" :title="translatedContentStructure.asset.name || ''" :source="translatedContentStructure.translation.funxtionVideoUrl" :poster="translatedContentStructure.translation.thumbnailUrl || ''"></m2h-video-player>
                </v-card>
              </div>
            </div>

            <!-- PLAYER DETAILS -->
            <div class="d-flex justify-space-between flex-wrap" v-if="!isMovieLoading">
              <div class="col-12 col-lg-6 pa-2 ma-0">
                <v-card
                    flat
                    color="transparent"
                >
                  <v-card-subtitle class="pb-0 text-break" v-if="translatedContentStructureParent"><a @click.prevent="navigateStructure(translatedContentStructureParent)">{{ translatedContentStructureParent.translation.title }}</a></v-card-subtitle>
                  <v-card-title class="pt-0 text-break"><strong>{{ translatedContentStructure.translation.title || '' }}</strong></v-card-title>
                  <!--<v-card-subtitle class="text-break" v-if="structure.asset.properties.duration">{{ structure.asset.properties.duration }}</v-card-subtitle>-->
                  <v-card-text v-html="translatedContentStructure.translation.description">
                  </v-card-text>
                </v-card>
              </div>
            </div>

            <v-divider class="my-3"></v-divider>
          </div>
            
        </v-container>
      </div>
    </div>

    <!-- SECTION STRUCTURE CHILDREN / SIBLINGS -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="!structureChildrenLoading">
        <!-- STRUCTURE CHILDREN -->
        <div class="col-12 ma-0 my-2 pa-0">
            <v-container fluid class="pa-2">
                <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="translatedContentStructureChildren.length">
                    <template v-for="(structureChild, n) in translatedContentStructureChildren">
                        <div class="ma-0 pa-2" :class="'col-' + (12 / columns)" v-if="structureChild.translation" :key="structureChild.identifier + '-' + n">
                            <v-card
                                    class="ma-2 my-0"
                                    color="transparent"
                                    flat
                                    tile
                                    height="100%"
                                    link
                            >
                                <v-img
                                    v-if="structureChild.asset.properties && structureChild.asset.properties.thumbnailUrl"
                                    :src="structureChild.asset.properties.thumbnailUrl"
                                    lazy-src="/assets/img/placeholder.png"
                                    :aspect-ratio="16/9"
                                    class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                                    eager
                                    cover
                                    @click.prevent="navigateStructure(structureChild)"
                                >
                                  <!-- CHIP FOR DURATION FUNXTION -->
                                  <v-chip
                                      v-if="structureChild.translation.duration && structureChild.type === 'FUNXTION_VIRTUAL_CLASS'"
                                      class="ma-2 rounded-lg"
                                      label
                                      small
                                      color="primary"
                                      style="position: absolute; top: 0; right: 0;"
                                  >
                                    {{ structureChild.translation.duration }}
                                  </v-chip>
                                  <!-- CHIP FOR DURATION VIMEO -->
                                  <v-chip
                                      v-if="structureChild.translation.duration && structureChild.type === 'VIMEO'"
                                      class="ma-2 rounded-lg"
                                      label
                                      small
                                      color="primary"
                                      style="position: absolute; top: 0; right: 0;"
                                  >
                                    {{ structureChild.translation.duration > 3600 ? $moment.utc(structureChild.translation.duration*1000).format("HH:mm:ss") : $moment.utc(structureChild.translation.duration*1000).format("mm:ss") }}
                                  </v-chip>
                                  <span class="white--text text-subtitle-1 font-weight-bold" style="text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);">{{ structureChild.translation.title }}</span>
                                </v-img>
                                <v-img
                                    v-else-if="structureChild.translation && structureChild.translation.thumbnailUrl"
                                    :src="structureChild.translation.thumbnailUrl"
                                    lazy-src="/assets/img/placeholder.png"
                                    class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                                    :aspect-ratio="16/9"
                                    eager
                                    cover
                                    @click.prevent="navigateStructure(structureChild)"
                                >
                                  <!-- CHIP FOR DURATION FUNXTION -->
                                  <v-chip
                                      v-if="structureChild.translation.duration && structureChild.type === 'FUNXTION_VIRTUAL_CLASS'"
                                      class="ma-2 rounded-lg"
                                      label
                                      small
                                      color="primary"
                                      style="position: absolute; top: 0; right: 0;"
                                  >
                                    {{ structureChild.translation.duration }}
                                  </v-chip>
                                  <!-- CHIP FOR DURATION VIMEO -->
                                  <v-chip
                                      v-if="structureChild.translation.duration && structureChild.type === 'VIMEO'"
                                      class="ma-2 rounded-lg"
                                      label
                                      small
                                      color="primary"
                                      style="position: absolute; top: 0; right: 0;"
                                  >
                                    {{ structureChild.translation.duration > 3600 ? $moment.utc(structureChild.translation.duration*1000).format("HH:mm:ss") : $moment.utc(structureChild.translation.duration*1000).format("mm:ss") }}
                                  </v-chip>
                                  <span class="white--text text-subtitle-1 font-weight-bold" style="text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);">{{ structureChild.translation.title }}</span>
                                </v-img>
                                <v-img
                                  v-else
                                  src="/assets/img/placeholder.png"
                                  lazy-src="/assets/img/placeholder.png"
                                  class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                                  :aspect-ratio="16/9"
                                  eager
                                  cover
                                  @click.prevent="navigateStructure(structureChild)"
                              >
                                <!-- CHIP FOR DURATION FUNXTION -->
                                <v-chip
                                    v-if="structureChild.translation.duration && structureChild.type === 'FUNXTION_VIRTUAL_CLASS'"
                                    class="ma-2 rounded-lg"
                                    label
                                    small
                                    color="primary"
                                    style="position: absolute; top: 0; right: 0;"
                                >
                                  {{ structureChild.translation.duration }}
                                </v-chip>
                                <!-- CHIP FOR DURATION VIMEO -->
                                <v-chip
                                    v-if="structureChild.translation.duration && structureChild.type === 'VIMEO'"
                                    class="ma-2 rounded-lg"
                                    label
                                    small
                                    color="primary"
                                    style="position: absolute; top: 0; right: 0;"
                                >
                                  {{ structureChild.translation.duration > 3600 ? $moment.utc(structureChild.translation.duration*1000).format("HH:mm:ss") : $moment.utc(structureChild.translation.duration*1000).format("mm:ss") }}
                                </v-chip>
                                <span class="white--text text-subtitle-1 font-weight-bold" style="text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);">{{ structureChild.translation.title }}</span>
                              </v-img>
                                <v-card-text class="d-flex justify-space-between align-start">
                                    <div>
                                        <div v-if="structureChild.translation.title" @click.prevent="navigateStructure(structureChild)"><strong>{{ structureChild.translation.title }}</strong></div>
                                        <!-- <div v-if="structureChild.episode">{{ $t('labels.episode') }} {{ structureChild.episode }}</div> -->
                                    </div>
                                    <div>
                                        <v-btn
                                                color="primary"
                                                icon
                                                small
                                                @click.prevent="toggleDescription(structureChild.identifier)"
                                        >
                                            <v-icon
                                                    v-if="!showDescriptions.includes(structureChild.identifier)"
                                                    dark
                                                    small
                                            >
                                                fal fa-chevron-down
                                            </v-icon>
                                            <v-icon
                                                    v-if="showDescriptions.includes(structureChild.identifier)"
                                                    dark
                                                    small
                                            >
                                                fal fa-chevron-up
                                            </v-icon>
                                        </v-btn>
                                    </div>
                                </v-card-text>
                                <v-card-text v-if="showDescriptions.includes(structureChild.identifier)" style="max-height: 200px;" class="overflow-y-auto">
                                    <div v-if="structureChild.translation.shortDescription" v-html="structureChild.translation.shortDescription"></div>
                                </v-card-text>
                            </v-card>
                        </div>
                    </template>
                </div>

            </v-container>
        </div>
    </div>

    <!-- SECTION STRUCTURE CHILDREN / SIBLINGS LOADING -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="structureChildrenLoading">
        <!-- STRUCTURE CHILDREN LOADING -->
        <div class="col-12 ma-0 my-2 pa-0">
            <v-container fluid class="pa-2">
                <!-- LOADER SECTION -->
                <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
                    <template v-for="n in 4">
                        <div class="col-12 col-sm-6 col-lg-3 ma-0 pa-2" :key="n">
                            <v-card
                                    class="ma-2 my-0"
                                    color="transparent"
                                    flat
                                    tile
                                    height="100%"
                            >
                                <v-skeleton-loader
                                        type="image"
                                ></v-skeleton-loader>
                                <v-card-text>
                                    <v-skeleton-loader
                                            class="mt-1"
                                            type="text"
                                    ></v-skeleton-loader>
                                    <v-skeleton-loader
                                            type="text"
                                    ></v-skeleton-loader>
                                </v-card-text>
                            </v-card>
                        </div>
                    </template>
                </div>
            </v-container>
        </div>
    </div>
    
    <!-- SLOT SECTION -->
    <slot></slot>
  </v-container>
</template>

<script>

import api from "@/api/api";
import Vue from "vue";
import i18n from "../services/i18n";
// import Vimeo from "@vimeo/player";

export default {
  name: "m2h-content",
  props: ['structureId', 'categoryId', 'serieId', 'videoId', 'mode', 'challengeId'],
  data() {
    return {
      structureLoading: false,
      structureChildrenLoading: false,
      collections: {},
      categories: {},
      collectionDetails: {},
      structure: {},
      structureChildren: [],
      structureParent: {},
      showDescriptions: [],
      movie: {},
      movieDetails: {},
      isMovieLoading: false, 
      baseUrl: '',
      userId: '',
      surveyReady: false,
    }
  },
  
  computed:{
    filteredCollections(){
      if (this.categoryId || this.serieId || this.videoId){
        return this.collectionDetails
      }
      return this.categories
    },
    
    isCollectionDetail(){
      return !!this.categoryId || !!this.serieId || !!this.videoId;
    },
      
    isContent(){
        let contentTypes = [
            "VIMEO",
            "TYPEFORM",
            "PDF",
            "FUNXTION_VIRTUAL_CLASS"
        ]
        return contentTypes.includes(this.structure.type);
    },

    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 6;
      }

      if (this.$vuetify.breakpoint.lg) {
        return 4;
      }

      if (this.$vuetify.breakpoint.md) {
        return 3;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 2;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 1;
      }

      return 1;
    },

    translatedContentStructure() {
      let structure = {...this.structure}
      structure.translation = null
      if (structure.asset && structure.asset.assetTranslations.length){
        //structure.asset.properties.menuTitle = structure.asset.assetTranslations[0].title
        if (structure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)){
          structure.translation = structure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)
        } 
        /*else if(structure.asset.assetTranslations.find((t) => t.default === true)){
          structure.translation = structure.asset.assetTranslations.find((t) => t.default === true)
        } else {
          structure.translation = structure.asset.assetTranslations[0]
        }*/
      }
      return structure
    },

    translatedContentStructureParent() {
      let structure = {...this.structureParent}
      structure.translation = null
      if (structure.asset && structure.asset.assetTranslations.length){
        //structure.asset.properties.menuTitle = structure.asset.assetTranslations[0].title
        if (structure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)){
          structure.translation = structure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)
        } 
        /*else if(structure.asset.assetTranslations.find((t) => t.default === true)){
          structure.translation = structure.asset.assetTranslations.find((t) => t.default === true)
        } else {
          structure.translation = structure.asset.assetTranslations[0]
        }*/
      }
      return structure
    },
    
    translatedContentStructureChildren() {
      let structureChildren = [...this.structureChildren]
      structureChildren.forEach((structure) => {
        structure.translation = null
        if (structure.asset && structure.asset.assetTranslations.length){
          //structure.asset.properties.menuTitle = structure.asset.assetTranslations[0].title
          if (structure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)){
            structure.translation = structure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)
          } 
          /*else if(structure.asset.assetTranslations.find((t) => t.default === true)){
            structure.translation = structure.asset.assetTranslations.find((t) => t.default === true)
          } else {
            structure.translation = structure.asset.assetTranslations[0]
          }*/
        }
      })
      return structureChildren
    }
  },

  mounted(){
    this.baseUrl = window.location.origin
    //this.fetchStructure(this.structureId)
    this.fetchContentStructure(this.structureId)

    this.$root.$on('language-changed', () => {
      if (this.translatedContentStructure && this.translatedContentStructure.type === 'TYPEFORM'){
        this.surveyReady = false
        this.getProfile()
      }
    })
  },
  
  methods: {
    async getSasUri(id){
      return await api.structures.getSasByMediaId(id).then((res) => {
          return res.data
      })
    },
    
    async fetchContentStructure(id){
      this.structureLoading = true
      
      let structure = await api.contentStructures.getStructureById(id).then((res) => { return res.data })
      
      if (structure){
        let shouldNotLoadParent = [
          "STRUCTURE_MENU",
          "STRUCTURE_SPOTLIGHT",
          "STRUCTURE_CHALLENGE"
        ]

        if (!shouldNotLoadParent.includes(structure.type) && structure.parents.length){
          this.structureParent = await api.contentStructures.getStructureById(structure.parents[structure.parents.length - 1]).then((res) => { return res.data })
        }
      }

      let shouldLoadChildren = [
        "STRUCTURE_MENU",
        "STRUCTURE_SUBMENU",
        "STRUCTURE_SPOTLIGHT",
        "STRUCTURE_CHALLENGE",
        "STRUCTURE_SERIE"
      ]
      if (shouldLoadChildren.includes(structure.type)){
        await this.fetchContentStructureChildren(id)
      }
      else if (structure.type === 'VIMEO' || structure.type === 'FUNXTION_VIRTUAL_CLASS' || structure.type === 'TYPEFORM' || structure.type === 'PDF'){
        await this.fetchContentStructureChildren(structure.parents[structure.parents.length - 1])
      }
      
      if (structure.type === 'TYPEFORM'){
        await this.getProfile()
      }
      
      if (structure.type === 'PDF') {
        this.$root.$emit('post-pdf-opened')
      }
      
      this.structure = structure
      
      this.structureLoading = false
    },

    async getProfile() {
      let profile = await api.account.getProfile().then((res) => { return res.data })
      if (profile){
        this.surveyReady = true
        this.userId = profile.identifier;
        let embedScript = document.createElement('script')
        embedScript.setAttribute('src', '//embed.typeform.com/next/embed.js')
        document.head.appendChild(embedScript)
        await this.logSurveyOpened()
      }
    },

    async logSurveyOpened() {
      this.$root.$emit('post-survey-opened')
    },
    
    async fetchContentStructureChildren(id){
      this.structureChildrenLoading = true
      
      let structureChildren = await api.contentStructures.getStructureChildrenById(id).then((res) => { return res.data })
      this.structureChildren = structureChildren.sort((a, b) => { return a.order - b.order })
      //let episode = 1
      /*this.structureChildren.forEach((x) => {
        if (x.type === 'VIMEO'){
          x.episode = episode
          episode += 1
        }
      })*/
      
      this.structureChildrenLoading = false
    },

    /*async fetchStructure(id){
        this.structureLoading = true
        let structure = await api.structures.getStructureById(id).then((res) => { return res.data })
        if (structure){
            if (structure.type === 'VIMEO'){
                await this.fetchMovie(structure.asset.assetId)
                // await this.fetchStructureParent(structure.parents[structure.parents.length - 1])
            }

            let shouldNotLoadParent = [
              "STRUCTURE_MENU",
              "STRUCTURE_SPOTLIGHT",
              "STRUCTURE_CHALLENGE"
            ]
          
            if (!shouldNotLoadParent.includes(structure.type)){
              await this.fetchStructureParent(structure.parents[structure.parents.length - 1])
            }
            
            let shouldLoadChildren = [
                "STRUCTURE_MENU",
                "STRUCTURE_SPOTLIGHT",
                "STRUCTURE_CHALLENGE",
                "STRUCTURE_SERIE"
            ]
            if (shouldLoadChildren.includes(structure.type)){
                await this.fetchStructureChildren(id)
            }
            else if (structure.type === 'VIMEO' || structure.type === 'FUNXTION_VIRTUAL_CLASS'){
                await this.fetchStructureChildren(structure.parents[structure.parents.length - 1])
            }
            
            if (structure.asset.properties && structure.asset.properties.thumbnailAssetId){
                structure.asset.properties.thumbnailUrl = await this.getSasUri(structure.asset.properties.thumbnailAssetId)
            }
            
            this.structure = structure
        }
        this.structureLoading = false
    },
    
    async fetchStructureParent(id){
        //this.structureLoading = true
        let structureParent = await api.structures.getStructureById(id).then((res) => { return res.data })
        if (structureParent){
            if (structureParent.asset.properties && structureParent.asset.properties.thumbnailAssetId){
                structureParent.asset.properties.thumbnailUrl = await this.getSasUri(structureParent.asset.properties.thumbnailAssetId)
            }
            this.structureParent = structureParent
        }
        //this.structureLoading = false
    },
    
    async fetchStructureChildren(id){
        this.structureChildrenLoading = true
        let structureChildren = await api.structures.getStructureChildrenById(id).then((res) => { return res.data })
        if (structureChildren){
            for await (let child of structureChildren){
                if (child.asset.properties && child.asset.properties.thumbnailAssetId){
                    // child.asset.properties.thumbnailUrl = await this.getSasUri(child.asset.properties.thumbnailAssetId)
                    // console.log('CHILD: ', child.asset.properties.thumbnailAssetId)
                    child.asset.properties.thumbnailUrl = await this.getSasUri(child.asset.properties.thumbnailAssetId)
                }
            }
            this.structureChildren = structureChildren.sort((a, b) => { return a.order - b.order })
            let episode = 1
            this.structureChildren.forEach((x) => {
                if (x.type === 'VIMEO' && x.asset.properties.liveVideo === "false"){
                    x.episode = episode
                    episode += 1
                }
            })
        }
        this.structureChildrenLoading = false
    },*/
    
    toggleDescription(id){
        if(this.showDescriptions.includes(id)){
            this.showDescriptions.splice(this.showDescriptions.indexOf(id), 1)
        } else {
            this.showDescriptions.push(id)
        }
    },
    
    logPlayer(){
        const that = this
        let videoExists = document.getElementById("video")
        if (videoExists){
            that.player = new Vimeo.Player('video'); // eslint-disable-line
            let interval
    
            // events
            that.player.on('play', async function() {
                // the video has started playing    
                let duration = 100
                if (await that.player.getDuration()){
                    duration = await that.player.getDuration()
                }
                that.videoStartTime = await that.player.getCurrentTime()
                let timing = duration / 10
                await that.logProgress()
                interval = setInterval(that.logProgress, timing.toFixed() * 1000)
            });
    
            that.player.on('pause', function() {
                // the video has started playing      
                that.logProgress()
                clearInterval(interval)
            });
    
            that.player.on('ended', function() {
                // the video has reached the end of playback
                that.logProgress()
                that.logProgress(true)
                clearInterval(interval)
            });
    
        }
    },
    
    async logProgress(completed) {
        let duration = await this.player.getDuration()
        let currentTime = await this.player.getCurrentTime()
        let progress = (currentTime / duration) * 100
        let videoTimeWatched = currentTime - this.videoStartTime
    
        if (videoTimeWatched > 0 || completed){
            let data = {
                videoPercentageWatched: progress.toFixed() || '',
                videoDuration: duration.toFixed() || '',
                videoTimeWatched: videoTimeWatched.toFixed()
            }
    
            this.videoStartTime = currentTime
    
            if (!completed){
              this.$root.$emit('post-vimeo-video-progress', data)
            }
    
            if (completed){
                this.$root.$emit('post-vimeo-video-completed', data)
            }
        }
    },
    
    async fetchVideoDetails(id){
      let movieDetails = await api.watch.getMovieDetails(id).then((res) => { return res.data })
      if (movieDetails){
        if (movieDetails.collections && movieDetails.collections.length){
            this.movieDetails = movieDetails.collections[0]
        }
        
        /*if (this.collectionDetails.collections && this.collectionDetails.collections.length){
          this.collectionDetails.collections = this.collectionDetails.collections.sort((a, b) => { return a.position - b.position })
        }*/
      }
    },
    
    async fetchMovie(id){
        this.isMovieLoading = true
        await this.fetchVideoDetails(id)
        let movie = await api.watch.getMovie(id)
            .then((res) => { return res.data })
            .catch((error) => {
              if (error.response.data.status === 403) {
                Vue.$toast.open({
                  type: 'error',
                  // Use the correct toast language
                  message:  i18n.getLocaleMessage(i18n.locale)['alerts']['noVideoRights'],
                  position: 'bottom',
                  duration: 10000,
                });                
              }
            })
        // let movieDetails = await api.watch.getMovieDetails(id).then((res) => { return res.data })
        if (movie){
            // console.log(movie)
            this.movie = movie
        }
        // if (movieDetails){
        //   console.log(movieDetails)
        // }
        this.isMovieLoading = false
    },
      
    navigateStructure(structure){
        /*if (structure.type === 'PDF'){
            this.navigateBlank('/pdf/' + structure.asset.assetId)
        } */
        /*else if (structure.type === 'TYPEFORM'){
            this.navigateBlank('/survey/' + structure.asset.assetId)
        }*/
        if (this.mode === 'challenge' && this.challengeId){
          this.navigate('/challenges/' + this.challengeId + '?str=' + structure.identifier)
        }
        else {
            this.navigate('/content/' + structure.identifier)
        }
    },
    
    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },

    navigateBlank(route){
      this.$root.$emit('m2h-loader-show')
        window.open(route, '_blank')
    },
  }
}
</script>

<style scoped>

</style>
